import { Component } from '@angular/core';
import { BaseMortgageApplicationComponent } from '../../../pages/base-mortgage-application.component';
import { MortgageApplicationStore } from './../../../services/mortgage-application-store';

@Component({
  selector: 'boi-additional-borrowings-btl',
  templateUrl: './additional-borrowings-btl.component.html',
  styleUrls: ['./additional-borrowings-btl.component.scss']
})
export class AdditionalBorrowingsBtlComponent extends BaseMortgageApplicationComponent {
  constructor(protected mortgageApplicationStore: MortgageApplicationStore) {
    super(mortgageApplicationStore);
  }
}
